import getOr from 'lodash/fp/getOr'
import * as yup from 'yup'
import { LEGAL_FORM_VALUES, SIZES_VALUES } from '../../constants'
import '../../../../../utils/validations/extendYup'
import { getOrEmpty, omitEmptyEntities } from '../utils'

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required(),
  cif: yup
    .string()
    .nifCif()
    .required(),
  constitution: yup
    .date()
    .max(new Date())
    .format('dd/MM/yyyy')
    .required(),
  legal_form: yup
    .number()
    .required()
    .oneOf(Object.values(LEGAL_FORM_VALUES)),
  other_legal_form: yup
    .string()
    .nullable()
    .when(['legal_form'] , {
      is: (value) => value === LEGAL_FORM_VALUES.OTHERS,
      then: yup.string().required(),
      otherwise: yup.string().nullable().notRequired()
    }),
  address: yup
    .string()
    .required(),
  locality: yup
    .string()
    .required(),
  province: yup
    .string()
    .required(),
  zip_code: yup
    .string()
    .zipCode()
    .required(),
  web: yup
    .string()
    .validUrl()
    .notRequired(),
  size: yup
    .number()
    .oneOf(Object.values(SIZES_VALUES))
    .required()
})

const mapPropsToValues = ({ application }) => ({
  name: getOr('', 'data.name')(application),
  cif: getOr('', 'data.cif')(application),
  constitution: getOr('', 'data.constitution')(application),
  legal_form: getOr('', 'data.legal_form')(application),
  other_legal_form: getOrEmpty('data.other_legal_form')(application),
  address: getOr('', 'data.address')(application),
  locality: getOr('', 'data.locality')(application),
  province: getOr('', 'data.province')(application),
  zip_code: getOr('', 'data.zip_code')(application),
  web: getOrEmpty('data.web')(application),
  size: getOr('', 'data.size')(application)
})

export default {
  mapPropsToValues,
  validationSchema,
  mapValuesToData: omitEmptyEntities
}
